import React from 'react';

const FollowUp = () => {
  return <div>FollowUp</div>;
};

export default FollowUp;
